import App from 'app/app.js';
import 'app/service/RouterService.js';

function LtOrderStatusBannerCtrl(RouterService, $location) {
  this.init = function () {
    var url = $location.url();
    this.isDashboardPage = url.includes('my-dashboard');
  };

  this.goToOrderStatus = function () {
    RouterService.goToOrderStatusLookup();
  };
  this.goToOrderHistory = function () {
    RouterService.goToOrderHistory();
  };
}

App.controller('LtOrderStatusBannerCtrl', ['RouterService', '$location', LtOrderStatusBannerCtrl]);
